<div
  [class]="containerClass"
  [style.width.px]="size"
  [style.height.px]="size">
  @if (showPicture) {
    <img
      class="picture-image"
      [src]="picture"
      [attr.width]="pictureSize"
      [attr.height]="pictureSize" />
  }
  @if (showFirstLetter) {
    <div
      class="letter-placeholder"
      [style.font-size.px]="letterSize">
      {{ name[0] }}
    </div>
  }
  @if (showIconPlaceholder) {
    <ppl-icon
      class="icon-placeholder"
      [width]="iconPlaceholderSize"
      [height]="iconPlaceholderSize"
      [svgIcon]="iconPlaceholder"></ppl-icon>
  }
  @if (showCustomIcon) {
    <ppl-icon
      [svgIcon]="icon"
      [width]="iconPlaceholderSize"
      [height]="iconPlaceholderSize"
      class="icon-placeholder"></ppl-icon>
  }
</div>
